import React, { useState } from 'react'

import { Carousel } from '@labrav/react-components'
import { ModalConfirmV2, ModalSizeVariants } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAws } from '@fortawesome/free-brands-svg-icons'
import { useScreenSize } from '@labrav/common'

interface CarouselWithModalProps {
  carouselData: Array<{
    image: string
    alt: string
    heading: string
  }>
  showHeading?: boolean
  autoPlayInterval?: number
  isCursorZoomIn?: boolean
  maxWidthPercentage?: number
  currentIndex?: number
  setCurrentIndex: (index: number) => void
}

export const CarouselWithModal: React.FC<CarouselWithModalProps> = ({
  carouselData,
  showHeading = false,
  currentIndex = 0,
  setCurrentIndex,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalIndex, setModalIndex] = useState(0)

  const { screenWidth } = useScreenSize()
  const maxWidth = screenWidth <= 1280 ? screenWidth * 0.7 : screenWidth * 0.65

  const handleImageClick = (index: number) => {
    setModalIndex(index)
    setCurrentIndex(index)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      <Carousel
        showHeading={showHeading}
        carouselData={carouselData}
        handleImageClick={handleImageClick}
        setCurrentIndex={setCurrentIndex}
        currentIndex={currentIndex}
      />

      <ModalConfirmV2
        title={carouselData[modalIndex]?.heading || ''}
        description=""
        icon={
          <FontAwesomeIcon
            icon={faAws}
            style={{ height: '16px', width: '16px' }}
          />
        }
        content={
          <Carousel
            showHeading={false}
            carouselData={carouselData}
            handleImageClick={handleCloseModal}
            setCurrentIndex={setModalIndex}
            currentIndex={modalIndex}
            isCursorZoomOut={true}
            showSliders={true}
          />
        }
        open={isModalOpen}
        titleAcceptButton=""
        titleCancelButton=""
        onDecline={handleCloseModal}
        variant={ModalSizeVariants.xLarge}
        hideAcceptButton={true}
        hideCancelButton={true}
        maxWidth={`${maxWidth}px`}
        onAccept={() => {}}
      />
    </>
  )
}
